import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import styles from "./ForgetPassword.module.css";
import stepper from "../../assets/stepper.png";
import stepperBox from "../../assets/stepperBox.png";
import stepperLine from "../../assets/stepperLine.png";
import stepperLineVer from "../../assets/stepperLineVer.png";
import stepperFilledBox from "../../assets/stepperFilledBox.png";
import stepperFilledLine from "../../assets/stepperFilledLine.png";
import stepperFilledLineVer from "../../assets/stepperFilledBoxVer.png";
import forgetStepper from "../../assets/forgetStepper.png";
import keyImg from "../../assets/keyImg.png";
import { Form } from "antd";
import { AntdInput, AntdPassInput, AntdSubmit } from "../../components";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import AlertAction from "../../store/Actions/AlertActions";
import AuthMiddleware from "../../store/Middlewares/AuthMiddleware";
// import forgetBackImg from "../../assets/forgetBackImg.png";
const ForgetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [current, setCurrent] = useState(0);
  const [otp, setotp] = useState();
  const [resCode, setResCode] = useState();
  const [resData, setResData] = useState();
  const [email, setEmail] = useState();
  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const otpHandler = (otp) => {
    setotp(otp);
  };
  const [form] = Form.useForm();
  const { height, width } = useWindowDimensions();

  const OnPressForgotPassword = (values) => {
    console.log('Success values:', values);
    setEmail(values?.email)
    let userData = {
      Email: values?.email,
    };
    dispatch(AuthMiddleware.ForgotPassword(userData))
      .then(data => {
        setResCode(data?.data?.code);
        console.log('code!!!', data?.data?.code);
        setResData(data?.data);
        if (data?.success) {
          // setForgetModalVisible(false);
          // setVerificationModalVisible(true);
          next()
        } else {
          // Alert.alert('Note', data?.message);
          dispatch(AlertAction.ShowAlert({ type: "warning", message: data?.message }))
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const OnPressVerify = () => {
    if (!otp) {
      // Alert.alert('Note', 'Enter Code');
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Enter Code' }))
    } else if (resCode == otp) {
      // setVerificationModalVisible(false);
      // navigation.navigate('ChangePassword', { resdata });
      next()
    } else {
      // Alert.alert('Note', 'Code does not matched');
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Code does not matched' }))
    }
  };

  const onPressChangePassword = (values) => {
    let userData = {
      Email: email,
      Password: values?.newPassword,
      ConfirmPassword: values?.confirmPassword,
    };
    if (!userData?.Password || !userData?.ConfirmPassword) {
      // Alert.alert('Note', 'Please fill all fields');
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Please fill all fields' }))
    }
    else if (/^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,20}$/.test(userData?.Password) == false) {
      // Alert.alert("Note", "Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!")
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Ensure password is of length 8, at least one uppercase and lowercase, at least one special case letter(@#!) and one number!' }))
    }
    else if (userData?.Password != userData?.ConfirmPassword) {
      // Alert.alert('Note', 'Password not match');
      dispatch(AlertAction.ShowAlert({ type: "warning", message: 'Password not match' }))
    }
    else {
      dispatch(AuthMiddleware.ConfirmPassword(userData))
        .then((data) => {
          // Alert.alert('Note', data?.message, [
          //   { text: 'OK', onPress: () => navigation.goBack() },
          // ]);
          dispatch(AlertAction.ShowAlert({ type: "warning", message: data?.message }))
          navigate('/')
        })
        .catch((error) => {
          console.warn(error);
        });
    }
  };

  return (
    <div className={styles.stepper}>
      <div className={styles.forgetPassword_container}>
        <div className={styles.stepperLeft}>
          {current == "0" ? (
            <div className={styles.stepsDiv}>
              <img src={stepperFilledBox} />

              <img
                src={width > 992 ? stepperFilledLine : stepperFilledLineVer}
              />

              <img src={stepperBox} />
              <img src={width > 992 ? stepperLine : stepperLineVer} />
              <img src={stepperBox} />
            </div>
          ) : current == "1" ? (
            <div className={styles.stepsDiv}>
              <img src={stepperFilledBox} />
              <img
                src={width > 992 ? stepperFilledLine : stepperFilledLineVer}
              />
              <img src={stepperFilledBox} />
              <img
                src={width > 992 ? stepperFilledLine : stepperFilledLineVer}
              />
              <img src={stepperBox} />
            </div>
          ) : current == "2" ? (
            <div className={styles.stepsDiv}>
              <img src={stepperFilledBox} />
              <img
                src={width > 992 ? stepperFilledLine : stepperFilledLineVer}
              />
              <img src={stepperFilledBox} />
              <img
                src={width > 992 ? stepperFilledLine : stepperFilledLineVer}
              />
              <img src={stepperFilledBox} />
            </div>
          ) : null}
        </div>
        <div className={styles.stepperRight}>
          <div className={styles.forgetPassword_content}>
            {current == "0" ? (
              <div className={styles.forgetPassword_Subcontent}>
                <h2>Forgot Password?</h2>
                <p>Enter Registered Email Address to Reset Password</p>
                <Form
                  name="basic"
                  form={form}
                  initialValues={{ remember: true }}
                  onFinish={OnPressForgotPassword}
                  // onFinishFailed={onFinishFailed}
                  autoComplete="off"
                  style={{ marginTop: "20px", marginBottom: "50px", zIndex:9999 }}
                >
                  <AntdInput
                    className={styles.input}
                    placeholder={"JohnDepp@gmail.com"}
                    name={"email"}
                    label="Email"
                    rules={[
                      {
                        require: true,
                        type: "email",
                        message: "Please enter your email",
                      },
                    ]}
                  />
                  <AntdSubmit
                    // onClick={() => next()}
                    text={"ResetPassword"}
                    buttonStyle={{
                      margin: "20px 0px",
                      height: "50px",
                      width: "60%",
                    }}
                  />
                </Form>
                <div className={styles.keyImgForget}>
                  <img src={keyImg} />
                </div>
              </div>
            ) : current == "1" ? (
              <div>
                <div className={styles.forgetPassword_Subcontent}>
                  <div className={styles.forgetPassword_txt}>
                    <h2>Verification Code</h2>
                    <p>
                      Please enter verification code sent on your registered
                      email address.
                    </p>
                  </div>
                  <div className={styles.verify_otp} style={{zIndex:9999}}>
                    <OtpInput
                      onChange={otpHandler}
                      // isInputSecure={true}
                      value={otp}
                      numInputs={4}
                      //   placeholder={'●●●●'}
                      containerStyle={styles.otp_container}
                      inputStyle={{
                        width: "4rem",
                        height: "4rem",
                        backgroundColor: "transparent",
                        border: "2px solid var(--secondary-color)",
                        borderRadius: "5px",
                        marginRight: "5px",
                        color: "white",
                      }}
                      focusStyle={{ outline: "none" }}
                      shouldAutoFocus={true}
                    />
                  </div>
                  <AntdSubmit
                    onClick={() => OnPressVerify()}
                    text={"Verify"}
                    buttonStyle={{
                      marginTop: '30px',
                      marginBottom: '80px',
                      height: "50px",
                      width: "200px",
                      zIndex:9999,
                    }}
                  />
                </div>
                <div className={styles.keyImgVerify}>
                  <img src={keyImg} />
                </div>
              </div>
            ) : current == "2" ? (
              <div>
                <div className={styles.changePasword_context}>
                  <div className={styles.changePasword_txt}>
                    <h2>Change Password</h2>
                    <p>Please Enter New Password and Confirm Password to Update Password</p>
                  </div>
                  <Form
                    name="basic"
                    form={form}
                    initialValues={{ remember: true }}
                    onFinish={onPressChangePassword}
                    // onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    style={{ marginTop: "20px", marginBottom: "50px" , zIndex:9999 }}
                  >
                    <AntdPassInput name={'newPassword'} placeholder={'********'} label='New Password' rules={[{ require: true, type: 'password', message: 'Please enter your New Password' }]} />
                    <AntdPassInput name={'confirmPassword'} placeholder={'********'} label='Confirm Password' rules={[{ require: true, type: 'password', message: 'Please enter your Confirm Password' }]} />
                    <AntdSubmit
                      // onClick={() => navigate('/')}
                      text={"Change Password"}
                      buttonStyle={{
                        marginTop: '10px',
                        height: "50px",
                        width: "100%",
                      }}
                    />
                  </Form>
                </div>
                <div className={styles.keyImgChPass}>
                  <img src={keyImg} />
                </div>
              </div>
            ) : null}
          </div>
          {/* <div className={styles.keyImg}>
            <img src={keyImg}/>
        </div> */}
        </div>
      </div>
    </div>
  );
};
export default ForgetPassword;
